<template>
<el-menu :unique-opened='true' :default-active="selectIndex">
  <!-- <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened" ></hamburger> -->
  <div class="menu-wrapper">
    <template v-for="item in sks" v-if="!item.hidden&&item.children">
      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow" :to="item.path+'/'+item.children[0].path"
        :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}" >
          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>
          <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title">{{item.children[0].meta.title}}</span>
        </el-menu-item>
      </router-link>
      <el-submenu v-else :index="item.name||item.path" :key="item.name" unique-opened='true'>
        <template slot="title">
          <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
          <span v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title}}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden&&child.super==false">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>

          <router-link v-else @click.native="toShow(item)" :to="item.path=='/machineMall'||status==1?item.path+'/'+child.path:''"  :key="child.name">
            <el-menu-item :index="item.path+'/'+child.path">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
    <el-dialog title="提示" :visible.sync="evpiStatus" width="25%" :modal-append-to-body='false' :close-on-click-modal='false'>
        <span class="evpiname">当前账号未完善部分必要信息，无法继续操作</span>
        <div slot="footer" class="dialog-footer">
            <span @click="evpiStatus=false" class="evpilast">下次再说</span>
            <el-button size="small" type="primary" @click="toEditcompany">去完善</el-button>
        </div>
    </el-dialog>
  </div>
  
</el-menu>

</template>

<script>
import { mapGetters } from 'vuex'
import { constants } from 'fs';
import Hamburger from '@/components/Hamburger'
import {login} from '../../../../api/login';
import {getToken} from '@/utils/auth';
export default {
    name:'SidebarItem',
    components:{
      Hamburger
    },
    props:{
        routes:{
            type:Array
        },
        isNest:{
            type:Boolean
        }
    },
    data(){
      return{
        sks:[],
        status:'',
        evpiStatus:false,
        selectIndex:this.$route.path
      }
    },
    watch: {
        '$route.path': function (newVal, oldVal) {
          this.selectIndex=newVal;
        }
      },
    created(){
      
      if(this.$store.getters.isperfectmsg){
        this.status=this.$store.getters.isperfectmsg
      }else{
        this.status=localStorage.getItem('isPerfectMsg')
      }
     this.abc();
    },
    mounted () {
      //console.log(this.sks)
    },
    methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    abc(){
        let das=JSON.parse(localStorage.getItem("data")),routes=this.routes,sks=[];
        return das.filter((item) => {
          
          return routes.filter(key => {    
            //console.log(item.name,key.meta)
              if(item.name==key.meta.title){
                this.sks.push(key) 
                //console.log('==========================')
                //console.log(key)
                //console.log('==========================')
                return item.data.filter(okl=>{
                 
                  return key.children.filter(ops=>{
                   
                    if(okl.name==ops.meta.title){
                      ops.super=false  
                    } 
                  })
                })
            } 
            
          })
          
        })
       
    },
    toShow(item){
      if(localStorage.getItem('isPerfectMsg')==0&&item.path!='/machineMall'){
        this.evpiStatus=true
      }
      
    },
    toEditcompany(){
      this.evpiStatus=false;
      this.$router.push({path:'/organization/editcompany'});
    }
  },
  computed:{
    
      ...mapGetters([
            'sidebar'
        ]),
  }

}
</script>
<style rel="stylesheet/scss" lang="scss">
.menu-wrapper{
  position: relative;
  .evpilast{
    color: #40a9ff;
    font-size: 14px;
  }
}
  .hamburger-container{
    display: flex;
    justify-content: flex-end;
    // position: fixed;
    // top: 0;
  }
  .el-dialog{
    z-index: 3000;
  }
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue